// import Home from './views/Home.vue'
// import About from './views/About'
import masterThesis from './components/ListThesises/MasterThesis'
export const routes = [
    {
        path: '/:countList',
        name: 'master',
        component:masterThesis
    },
    {
        path: '/',
        name: 'master',
        component: masterThesis,
    }
]